// extracted by mini-css-extract-plugin
export default {"tooltip":"jo-z","sharingV2":"ko-z","sharingIconsV2":"lo-z","links":"mo-z","link":"no-z","facebookV2":"oo-z","twitterV2":"po-z","pinterestV2":"qo-z"};